import { Avatar } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StepIcon = ({ icon, color }) => {
  return (
    <Avatar
      icon={<FontAwesomeIcon icon={icon} fontSize={16} />}
      style={{
        display: 'flex', // Centra el icono verticalmente
        backgroundColor: color,
      }}
    />
  );
};